import { render, staticRenderFns } from "./Setores.vue?vue&type=template&id=7cfdf513"
import script from "./Setores.vue?vue&type=script&lang=js"
export * from "./Setores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports